module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {

	var methods = {
		//will store fields info .. required only for data modification
		loadConfig: function() {},

		setMethod: function(method) {
			this._method = method;
			this._jsonize = false;
			return this;
		},

		abort: function () {
			this._loadStatus = 'notLoaded';

			this.getApi().abort();
		},

		// can take args ->
		// (key, val) pair or
		// object
		setTransitParameter: function() {
			if (arguments.length === 2) {
				this._transitParameters[arguments[0]] = arguments[1];
			} else if (arguments.length === 1 && fox.isObject(arguments[0])){
				fox.each(arguments[0], function (_val, _key) {
					this._transitParameters[_key] = _val;
				}, this);
			}

			return this;
		},

		isLoaded: function() {
			return this._loadStatus === 'success';
		},

		clearTransitParameters: function(key) {
			if (key !== undefined) {
				if (fox.isString(key) && this._transitParameters[key]) {
					this._transitParameters[key] = null;
					delete this._transitParameters[key];	
				}
			} else {
				this._transitParameters = {};
			}

			return this;
		},

		isActive: function() {
			return true;
		},
		//object commands. For all id is optional. Using pointer by default.

		getApi: function() {
			if (!this._api) {
				this._api = new fox.Api(null, this._wom).method(this._method);
				this._api.setOption('sendTimezone', true).setOption('cacheChannel', this.getOption('cacheChannel'));
				this.handleEvent(this._api, 'success', fox.bind(this.processResponse, this));
				this.handleEvent(this._api, ['error', 'failure'], fox.bind(this.processError, this));
			}
			return this._api;
		},

		activate: function() {
			this.callParent('activate', arguments);
			if (this._loadStatus === 'loading') {
				var last = this.getApi().lastResponse;
				if (last) {
					if (last.error) {
						this.processError(last);
					} else {
						this.processResponse(last);
					}
				} else {
					this._loadStatus = 'notLoaded';
				}
			}
		},

		loading: function () {},

		load: function(doNotReload) {
			if (!this.isReady()) return false;
			if (doNotReload && this.isLoaded()) return;

			this._loadStatus = 'loading';

			this.dispatchEvent('loading');
			this.hookWrapper('loading');
			
			var api = this.getApi();

			if (this._pm) this._pagerModePreLoadHook();

			this._iterators = {};
			
			var loadPromise = this.wait('loaded');

			api.send(
				fox.filter({
					'class': this._class,
					filter: this._filter,
					customFilter: this._customFilter,
					fields: fox.arrayUnique(this._fields),
					sorting: this._sort,
					limit: this._limit,
					offset: this._offset,
					metaFields: this._metaFields,
					transitParameters: this._transitParameters
				}),
				this._jsonize
			);

			return loadPromise;
		},
				
		setReadyState: function(state) {
			this._ready = state;
			return this;
		},
		
		isReady: function() {
			return this._ready;
		},

		processError: function(response) {
			this._loadStatus = 'error';
			this.dispatchEvent('loaded');
			this.dispatchEvent('loadError');
		},

		isEmpty: function() {
			return	fox.isEmpty(this._collection);
		},

		fillIndexedCollection: function () {
			this._indexedCollection = [];
			for(var id in this._collection) {
				this._indexedCollection.push(this._collection[id]);
			}
		},

		processResponse: function(response) {
			this._loadStatus = 'success';
			response.answer && (response = response.answer.response);

			this.hookWrapper('prepareResponse', response);

			this.set(this._apiResponse);

			if (this._pm) {
				this._pagerModePostLoadHook();
			}
			this.hookWrapper('loaded');
		},

		prepareResponse: function(response) {
			this._apiResponse = response.dataLayer || response;
		},
		
		loaded: function() {
			this.dispatchEvent('loaded');
		},
		//setter for LIMIT, OFFSET, FIELDS
		/**
		 *offset: 	set('offset', number);
		 *limit: 	set('limit', [number, number]) or set('limit', number);
		 *fields: 	set('fields', [Array]);
		*/
		set: function (param, val, val2) {
			if (fox.isObject(param)) {
				for (var p in param) {
					this.set(p, param[p]);
				}
				return this;
			}
			if (!param) {
				return this;
			}
			switch(param) {
				case 'filter':
					return this.addFilter.apply(this, Array.prototype.slice.call(arguments, 1));
				case 'sorting':
					return this.addSorting.apply(this, val);
				default:
					if (!fox.isString(param)) {
						return this;
					}
					var method = 'set' + fox.upCharFirstLetter(param);
					if (this[method]) {
						return this['set' + fox.upCharFirstLetter(param)](val);
					}
				break;
			}
			return this;
		},

		get: function (param) {
			return this['get' + fox.upCharFirstLetter(param)]();
		},

		/* GETTERS & SETTERS */
		
		// class
		setClass: function(className) {
			this._class = className;
			return this;
		},

		getClass: function() {
			return this._class;
		},

		//fields

		addFields: function(fields) {
			if (fox.isArray(fields)) {
				this._fields = fox.merge(this._fields, fields);
			}

			return this;
		},

		addField: function(field) {
			this._fields.push(field);
			
			return this;
		},

		setFields: function(fields) {
			this._fields = fields;
			return this;
		},

		fillRelatedDl: function(dl, myPath, relField, myField) {
			var myObj, relObj, relDl, createDl = true;
			while ((myObj = this.iterateObject('fillDl'))) {
				relDl = myObj.get(myPath);
				if (!fox.isSet(relDl)) {
					myObj.set(myPath, createDl ? fox.createDl() : []);
				}
				relDl = myObj.get(myPath);

				while ((relObj = dl.iterateObject('fillDl1'))) {
					if (relObj.get(relField) == myObj.get(myField)) {
						if (createDl) {
							relDl.addObject(relObj);
						}
					}
				}
			}
		},

		// limit && offset
		setLimit: function(val) {
			if (fox.isArray(val)) {
				this._limit = val[0];
				this.setOffset(val[1]);
			} else {
				this._limit = val;
			}
			return this;
		},

		getLimit: function() {
			return this._limit;
		},

		setOffset: function(val) {
			this._offset = val;
			return this;
		},

		getOffset: function() {
			return this._offset;
		},

		/*filter: addFilter({param})
			*Filter {param} structure
				* fields: Array - required
				* values: Array - required
				* condition: String - optional
			*Filter function signature
				* 1) addFilter({filter})
				* 2) addFilter('alias', {filter})
				* 3) addFilter([fields], [values])
				* 4) addFilter([fields], [values], 'condition')
				* 5) addFilter('alias', [fields], [values], 'condition')
				* 6) addFilter([{filter}, {filter1}....])
		*/
		addFilter: function() {
			var filterPrefix = '_jsFilter';

			switch (arguments.length) {
				case 1:
					if (fox.isArray(arguments[0])) {
						fox.each(arguments[0], function(filter) {
							this.addFilter(filter);
						}, this);
						return this;
					} else if (!arguments[0].fields) {
						fox.each(arguments[0], function(filter, alias) {
							filter.alias = alias;
							this.addFilter(filter);
						}, this);
						return this;
					}
					var alias = arguments[0].alias || filterPrefix + this._filterId++;
					delete arguments[0].alias;
					this._filter[alias] = this.checkFilter(arguments[0], true);
				break;
				case 2:
					if (fox.isString(arguments[0]) && fox.isObject(arguments[1])) {
						this._filter[arguments[0]] = this.checkFilter(arguments[1], true);
						break;
					}
					if (fox.isArray(arguments[0], arguments[1])) {
						this._filter[filterPrefix + this._filterId++] = this.checkFilter({fields: arguments[0], values: arguments[1]}, true);
						break;
					}
					this.checkFilter(null, true);
				break;
				case 3: case 4:
					if (fox.isString(arguments[0])) {
						this._filter[arguments[0]] = this.checkFilter({fields: arguments[1], values: arguments[2], condition: arguments[3] || null}, true);
					} else {
						this._filter[filterPrefix + this._filterId++] = this.checkFilter({fields: arguments[0], values: arguments[1], condition: arguments[2] || null}, true);
					}
				break;
			}
			return this;
		},

		setCustomFilter: function(filter) {
			this._customFilter = filter;
			return this;
		},

		dropFilter: function(alias) {
			delete this._filter[alias];
			return this;
		},

		clearAllFilters: function() {
			this._filter = {};
			return this;
		},

		isFilter: function(alias) {
			return !fox.isEmpty(this._filter[alias]) ? true : false;
		},
		
		checkFilter: function(filter, throwError) {
			if (!filter || !filter.fields || (!filter.values && !filter.condition)) {
				if (throwError) {throw new Error('Missing params for filter');} else {return false;}
			}
			if (!filter.fields.length) {
				if (throwError) {throw new Error('Missing fields for filter');} else {return false;}
			}

			if (!filter.condition) {
				delete filter.condition;
			}
			return filter;
		},

		//sort

		addSorting: function(field, descent, alias) {
			alias || (alias = field + '_' + (descent ? 'desc' : 'asc'));
			this._sort[alias] = [field, descent || 0];
			return this;
		},

		dropSorting: function(alias) {
			delete this._sort[alias];
			return this;
		},

		clearSorting: function() {
			this._sort = {};
			return this;
		},

		// meta
		setMetaFields: function(fields) {
			this._metaFields = fields || {};
			return this;
		},

		setMetaField: function(name, value) {
			this.addMetaField(name, value);
		},

		addMetaField: function(name, value) {
			this._metaFields[name] = value || 1;
			return this;
		},

		alterMetaField: function(name, value) {
			if (!this._metaFields[name]) {
				return this.setMetaField(name, value);
			}
			this._metaFields[name] = fox.mergeRecursive(this._metaFields[name], value);
			return this;
		},

		getMetaValue: function(name) {
			return this._meta[name];
		},

		setMeta: function(meta) {
			this._meta = meta;
		},

		setMetaValue: function(name, value) {
			this._meta[name] = value;
		},

		//collection

		setCollection: function(collection) {
			this._collection = collection;
			this.fillIndexedCollection();
			return this;
		},

		getCollection: function() {
			return this._collection;
		},

		getObjectValue: function(name) {
			return this.getObject().get(name);
		},

		getObjectRelation: function(name, dl) {
			return this.getObject().relation(name, dl);
		},

		resetIterator: function(iteratorAlias) {
			delete this._iterators[iteratorAlias];
		},
		
		iterateObject: function(iteratorAlias, params) {
			params = params || {};
			if (!this._iterators[iteratorAlias]) {
				if (!this.getCount()) {
					return false;
				}
				this._iterators[iteratorAlias] = new fox.DataObject(this);
				if (params.backward) {
					this._iterators[iteratorAlias].end();
				}
				return this._iterators[iteratorAlias];
			}

			var obj = this._iterators[iteratorAlias];
			obj = params.backward ? obj.prev() : obj.next();
			
			if (!obj) {
				this._iterators[iteratorAlias] = new fox.DataObject(this);

				return false;
			}

			return obj;
		},

		getObject: function() {
			return new fox.DataObject(this);
		},

		toJSON: function() {
			return JSON.stringify(this.collection);
		},

		addObjects: function(objects, options) {
			if (fox.isArray(objects)) {
				for (var i = 0, length = objects.length; i < length; i++) {
					this.addObject(objects[i], options);
				}
			} else {
				console.log('addObjects requires array');
			}

			return this;

		},

		addObject: function(object, options) {
			if (!object) {
				return false;
			}

			options = options || {};

			var method = options.top ? 'unshift' : 'push';

			if (object.get) {
				this._collection[method](object.getAll());
			} else {
				this._collection[method](object);
			}

			this._iterators = [];
			this.fillIndexedCollection();
			return this;
		},

		extractObjectByIndex: function(index) {
			var obj = this._collection.splice(index, 1)[0];
			this.fillIndexedCollection();
			return obj;
		},

		//local methods
		findOne: function(field, value, params) {
			params = params || {};
			params.one = true;
			return this.find(field, value, params);
		},
		
		find: function(field, value, params) {
			params = params || {};
			var obj, res = [];
			if (fox.isArray(field)) {
				if (field.length !== value.length) {
					console.log('dl find error: fields count should be same as values count');
					return false;
				}
				while ((obj = this.iterateObject('_find'))) {
					var passed = 1;
					for (var i = field.length - 1; i >= 0; i--) {
						passed = passed && obj.get(field[i]) == value[i]
					}
					if (passed) {
						if (params.one) {
							this._iterators._find = false;
							return obj;
						}
						res.push(obj.getAll());
					}
				}
			} else {
				while ((obj = this.iterateObject('_find'))) {
					if (obj.get(field) == value) {
						if (params.one) {
							this._iterators._find = false;
							return obj;
						}
						res.push(obj.getAll());
					}
				}
			}

			if (params.one) {
				return false;
			}
			return fox.createDl().addObjects(res);
		},


		//data & methods for pagination
		_pagerModePreLoadHook: function() {
			if (!this._pager.notSetTotalCount) {
				this.setMetaField('totalCount');
			}
			this.setLimit(this._pager.rpp);
			this.setOffset(this._pager.rpp * (this._pager.cp - 1));
		},

		_pagerModePostLoadHook: function() {
			this._pager = {
				rpp: this.getLimit(),
				cp: (Math.ceil(this.getOffset() / this.getLimit()) + 1),
				total: (Math.ceil(parseInt(this.getMetaValue('totalCount')) / this.getLimit())),
				notSetTotalCount: this._pager.notSetTotalCount
			};
			this._pager.next = (this._pager.cp >= this._pager.total) ? 0 : this._pager.cp + 1;
			this._pager.prev = (this._pager.cp <= 1) ? 0 : this._pager.cp - 1;
		},

		initPagerMode: function(notSetTotalCount) {
			if (!this._pm) {
				this._pm = true;
				this._pager = {
					rpp: this._limit,
					cp: Math.ceil(this.getOffset() / this.getLimit()) + 1,
					prev: 0,
					next: 0,
					total: 0,
					notSetTotalCount: !!notSetTotalCount
				};
			}
			return this;
		},

		clearCollection: function() {
			this._collection = [];
			this._indexedCollection = [];
			this._loadStatus = 'notLoaded';
			return this;
		},

		getCount: function() {
			return fox.count(this._collection);
		},

		getPagerData: function() {
			return this._pager;
		},

		getNextPageNumber: function() {
			return this._pager.next;
		},

		nextPage: function() {
			this.setCp(this.getNextPageNumber());
			this.load();
			return this;
		},

		getPrevPageNumber: function() {
			return this._pager.prev;
		},

		prevPage: function() {
			this.setCp(this.getPrevPageNumber());
			this.load();
			return this;
		},

		changePage: function(num) {
			this.setCp(num).load();
			return this;
		},

		setRpp: function(rpp) {
			this._pager.rpp = rpp;
			this.setCp(1);
			return this;
		},

		getRpp: function() {
			return this._pager.rpp;
		},

		setCp: function(cp) {
			this._pager.cp = cp;
			return this;
		},

		getCp: function() {
			return this._pager.cp;
		},

		clone: function(dl) {
			var props = [
				'_filter',
				'_fields',
				'_sort',
				'_limit',
				'_offset',
				'_metaFields',
				'_class',
				'_method',
				'_jsonize',
				'_autoLoad',
				'_transitParameters',

				//non-options
				'_config',
				'_pm',
				'_collection',
				'_meta',
				'_index',
				'_indexedCollection',
				'_filterId',
				'_sortId',
				'_pager',
				'_objClass',
				'_loadStatus',
				'_iterators',
				'_ready'
			];

			dl = dl || fox.createDataLayer();

			fox.each(props, function(name) {dl[name] = fox.clone(this[name]);}, this);
			return dl;
		}
	};

	var DataLayer = function(options) {
		this._womHandlers = {};
		this._events = {};
		this._womWaitingActivationHandlers = {};
		this._registerOptionsWeights = {};
		this._filter = {}; this._fields = []; this._sort = {}; this._limit = 25; this._offset = 0; this._config = {}; this._pm = false;
		this._collection = []; this._metaFields = {}; this._meta = {}; this._index = {id: null}; this._indexedCollection = [];
		this._filterId = 1;
		this._class = null;
		this._sortId = 1;
		this._pager = {};
		this._objClass = 'DataLayer';
		this._loadStatus = 'notLoaded';
		this._options = {};
		this._iterators = {};
		options = options || {};
		this._handledEvents	= [];
		this._hooks = {};
		this._ready = true;
		this._method = 'dataLayer.view';
		this._jsonize = true;
		this._autoLoad = false;
		this._transitParameters = {};
		this.options = {};

		this.configure.apply(this, arguments);
		if (!options.skipRegistration && fox.wom) {
			this.setWom(fox.wom);

			fox.wom.registerObject(this);
		}
	};

	var DataLayerClass = fox.extend(methods, fox.BaseObject, DataLayer, 'DataLayer');

	fox.registerWidget('Datalayer', fox.mixin({	
		configure: function(options) {
			this.registerOptions('', {
				limit: 25,
				offset: 0,
				method: 'dataLayer.view',
				jsonize: false,
				sendTimezone: true,
				forwardWom: {
					startWorking: '#api',
					stopWorking: '#api'
				},
				'handleWom.processResponse': {
					widget: '#api',
					event: 'success',
					callback: 'processResponse'
				},
				'handleWom.processError': {
					widget: '#api',
					event: ['error', 'failure'],
					callback: 'processError'
				}
			});

			this.callParent('configure', arguments);
		},
		
		_getObjectClass: function () {
			return 'DataLayer';
		},

		init: function() {
			this._filterId = 1;
			//options
			this._filter = {};//this.getOption('filter') || {};
			if (this.getOption('filter')) {
				this.addFilter(this.getOption('filter'));
			}
			
			this._fields = this.getOption('fields') || [];
			this._sort = this.getOption('sorting') || {};
			this._limit = this.requireOption('limit');
			this._offset = this.requireOption('offset');
			this._metaFields = this.getOption('metaFields') || {};
			this._class = this.getOption('class');
			this._method = this.requireOption('method');
			this._jsonize = this.requireOption('jsonize');
			this._autoLoad = this.getOption('autoLoad') || false;
			this._transitParameters = this.getOption('transitParameters') || {};

			//non-options
			this._config = {};
			this._pm = false;
			this._collection = [];
			this._meta = {};
			this._index = {id: null};
			this._indexedCollection = [];
			this._filterId = 1;
			this._sortId = 1;
			this._pager = {};
			this._objClass = 'DataLayer';
			this._loadStatus = 'notLoaded';
			this._iterators = {};
			this._ready = true;

			this.embedWidget('api', 'Api', this.getOption('apiParams') || {});
			this.callParent('init', arguments);
		},

		initWithChildren: function() {
			if (this.getOption('autoLoad')) {
				this.load();
			}
		},

		getApi: function() {
			var api = this.requireEmbeddedWidget('api');

			api
				.setOption('method', this._method)
				.setOption('useSocket', this.getOption('useSocket'))
				.setOption('sendTimezone', this.requireOption('sendTimezone'))
				.setOption('cacheChannel', this.getOption('cacheChannel'));

			return api;
		}


	}, methods), 'Controller');

	fox.createDataLayer = function(options) {
		return new DataLayerClass(options);
	};

	fox.createDl = function() {
		return new DataLayerClass({skipRegistration: true});
	};

	fox.hydrateDl = function (data, dl) {
		return (dl || fox.createDl()).set(data || {});
	};

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/data/datalayer.js
// module id = 183
// module chunks = 0